import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SMSservice } from '../../../../core/services/sms.service';
import { CommmonUtil } from '../utils/common.util';
import {Insurance ,InsuranceGroup} from '../../models/dashbaord.model';
import { HttpClient } from '@angular/common/http';
import { ProfileService } from '../../../../services/profile.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { combineLatest, debounceTime, distinctUntilChanged, map, Observable } from 'rxjs';
import { Router } from '@angular/router';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  encapsulation: ViewEncapsulation.None,
})

export class ProfileComponent implements OnInit, AfterViewInit {
  @ViewChild('profileInfo', { static: false }) profileInfo!: ElementRef;
  patientProfileData: any = [];
  categorizedRecords: { category: string, insuranceGroup: InsuranceGroup }[] = [];
  patallergiesData:any;
  PatientPhoneNo: any;
  patAge:any;
  avatarUrl: string = '';
  isPopupVisible:boolean = false;
  InsuCardsFG! : FormGroup;
  insuPopupOpen: boolean = false;
  dropdownOptions = [
    { Id: 0, label: 'NONE' },
    { Id: 1, label: 'PRIMARY' },
    { Id: 2, label: 'SECONDARY' },
    { Id: 3, label: 'TERTIARY' },
  ];
  currentCardIndex: number = 0;
  currentIndex = 0;
  elinkParams: any;
  pharmacyName:any;
  npi :any;
  pharmacyInfo:any;
  inputValue: any;
  insuranceData: any;
  insuName: any;
  isImageCaptured: boolean = false;
  visibleDots: any = [];
  isInputTouched: boolean = false;
  insuranceCode: any = null;
  insuPhoneNumber: any;
  isFrmDropDown: boolean = false;
  matchingInsurance: any;
  insurerId: any;
  filteredData: any;
  frmAdd: boolean = false;
  searchTerm: string = '';
  isInsuranceExists: boolean = false;
  isInsuranceInactive: boolean = false;
  isAllCardsVisible: boolean = false;
  showAllCards: boolean = false;
  matchingInsuPriority: any = [];
  binPcnExists = false;
  controlInvalid = false;
  isPhoneNumUpdated = false;
  isInsuExists = false;
  isPhoneExists = false;
  showCamera = false;
  @ViewChild('fileInput') fileInput!: ElementRef;
  isCaptured: boolean = false;
  @ViewChild('video', { static: false }) video!: ElementRef;
  @ViewChild('canvas', { static: false }) canvas!: ElementRef;
  stream: MediaStream | null = null;
  capturedImage: string | null = null; 
  extractedImage : any;
  isFrmInsuranceCapture: boolean = false;
  errorMessage: string = '';
  selectedOption: any = null;
  showDropdown = false;
  @ViewChild('dropdownContainer') dropdownRef!: ElementRef;
  constructor(private smsService:SMSservice, private commmonUtil:CommmonUtil,private http: HttpClient, private _fb: FormBuilder, private _profileSvc : ProfileService,
  private _peSvc : PatientEngagementService,
  private _cmUtil : CommmonUtil, private ngZone: NgZone,  private _router: Router,
  ){
    this.avatarUrl = this._profileSvc.getImage();
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
  }
  ngAfterViewInit() {
    this.adjustPaymentListHeight();
    window.addEventListener('resize', this.adjustPaymentListHeight.bind(this));
  }
  adjustPaymentListHeight() {
    const deviceType = this.getDeviceType();
    let bottomHeight = 20;
    this.ngZone.runOutsideAngular(() => {
    requestAnimationFrame(() => {
     this.commmonUtil.adjustElementHeight(this.profileInfo, deviceType, bottomHeight);
    });
  })
  }
  getDeviceType(): 'desktop' | 'tablet' | 'mobile' {
    const viewportWidth = window.innerWidth;
    if (viewportWidth <= 767) {
      this.isAllCardsVisible = false;
      return 'mobile';
    } else if (viewportWidth <= 1024) {
      this.isAllCardsVisible = false;
      this.showAllCards = false;
      return 'tablet';
    } else {
      this.isAllCardsVisible = false;
      this.showAllCards = false;
      return 'desktop';
    }
  }
  ngOnInit(): void {
    this.isAllCardsVisible = false;
    this.gerProfile();
    this.getInsuranceDataFrmInsuranceFile();
    this.createInsuFG();
    this.updateVisibleDots();
    this.enableForControls();
    combineLatest([
    this.InsuCardsFG.get('BIN')!.valueChanges,
    this.InsuCardsFG.get('PCN')!.valueChanges,
    this.InsuCardsFG.get('InsuranceName')!.valueChanges,
    this.InsuCardsFG.get('PersonCode')!.valueChanges,
     this.InsuCardsFG.get('PolicyNumber')!.valueChanges
    ]).pipe(debounceTime(400))
    .subscribe(() => {
      this.checkDuplicateInsuranceAndHandle(this.InsuCardsFG);
    });
  }

  createInsuFG(){
    this.InsuCardsFG = this._fb.group({
      BIN: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(/^\d{6}$/)])],
      PCN: ['', Validators.required],
      InsuranceName: ['', Validators.required],
      GroupNumber: [''],
      PhoneNumber: ['', Validators.pattern(/^\(\d{3}\)-\d{3}-\d{4}$/)],
      PolicyNumber: ['', Validators.required],
      PersonCode: [''],
      Priority: [''],
      PharmacyNPI: [null],
      PatientId: [0],
    });    
  }
  getInsuranceDataFrmInsuranceFile(){
    this._peSvc.getInsuranceFileData(this.elinkParams?.npi).subscribe((resp)=>{
      if(resp){
        this.insuranceData = resp.records;
      }
    });
  }
  enableForControls(){
    this.InsuCardsFG.get('InsuranceName')?.enable();
    this.InsuCardsFG.get('PhoneNumber')?.enable();
    this.isInsuranceExists = false;
    this.isInsuExists = false;
    this.isPhoneExists = false;
    this.isInsuranceInactive = false;
    this.errorMessage = '';
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustPaymentListHeight();
  }

  toggleCards(){
      this.showAllCards = true;
      this.isAllCardsVisible = false;
    }
    closeAllCards(){
      this.isAllCardsVisible = true;
      this.showAllCards = false;
    }

    async validateBinPcnCombination(bin: string, pcn: string) {
        if (bin?.length !== 6 && pcn?.length) {
            return;
        }
        const searchTerm = `${bin},${pcn}`;
        const filteredResults = this.filterByPcnBin(searchTerm);
        if (filteredResults.length === 0) {
            this.binPcnExists = false;
            this.InsuCardsFG.get('InsuranceName')?.enable();
            this.InsuCardsFG.get('PhoneNumber')?.enable();
        } else {
          let isInsuExs = null;
          let isInsuActv = null;
          const payload = {
            patientid : this.patientProfileData?.patientInfo?.patientid,
            pharmacyNPI : this.elinkParams?.npi,
            insuranceId : filteredResults[0].id,
            insurerId : filteredResults[0].insuCarrierId
          };
            isInsuExs = await this._peSvc.checkIsInsuranceExistOrNot(payload).toPromise();
            isInsuActv = await this._peSvc.checkIsInsuranceActiveOrNot(filteredResults[0].insuCarrierId,this.elinkParams?.npi).toPromise();
            if (isInsuExs) {
              this.InsuCardsFG.patchValue({InsuranceName : null,BIN : null, PCN : null});
              this.insuranceCode = " ";
              this.insuranceCode = null;
              this.isInsuranceExists = true;
              this.isInsuranceInactive = false;
              this.InsuCardsFG.get('InsuranceName')?.enable();
              this.InsuCardsFG.get('PhoneNumber')?.enable();
            } else if (!isInsuActv) {
              this.InsuCardsFG.patchValue({InsuranceName : null,BIN : null, PCN : null});
              this.insuranceCode = " ";
              this.insuranceCode = null;
              this.isInsuranceExists = false;
              this.isInsuranceInactive = true;
              this.InsuCardsFG.get('InsuranceName')?.enable();
              this.InsuCardsFG.get('PhoneNumber')?.enable();
            } else {
              if(filteredResults && filteredResults[0]){
                this.insuranceCode = filteredResults[0].insuranceName?.trim();
                this.binPcnExists = true;
                this.insurerId = filteredResults[0].insuCarrierId
                this.InsuCardsFG.patchValue({
                  InsuranceName : filteredResults[0].insuranceName?.trim(),
                  PhoneNumber : filteredResults[0].phoneNumber});
                  this.isPhoneNumUpdated = filteredResults?.[0]?.phoneNumber ? false : true;
                  if(filteredResults?.[0]?.insuranceName){
                    this.InsuCardsFG.get('InsuranceName')?.disable();
                    this.isInsuExists = true;
                  }
                  filteredResults?.[0]?.insuranceName ? this.InsuCardsFG.get('InsuranceName')?.disable() : '';
                  if(filteredResults?.[0]?.phoneNumber){
                    this.InsuCardsFG.get('PhoneNumber')?.disable();
                    this.isPhoneExists = true;
                  }
                  this.isInsuranceExists = false;
                  this.isInsuranceInactive = false;
                  this.focusNextEnabledField('PCN');
              }
        }
    }
  }
    filterByPcnBin(term: any) {
        const searchTerms = term?.split(",");
        const insuranceList = this.insuranceData ? [...this.insuranceData] : [];
    
        if (insuranceList.length > 0) {
            ["e1comm", "..."]?.forEach(codes => {
                const index = insuranceList.findIndex((val: any) => 
                    (val?.["insurerCode"])?.toLowerCase() === codes
                );
                if (index > -1) {
                    insuranceList.splice(index, 1);
                }
            });
        }
    
        let filteredData = insuranceList.filter((v: any) => {
            let valExists = false;
            ["processorNum", "binNum"].forEach(key => {
                const val = v[key] ? v[key] : "";
                valExists = valExists || val.toString().toLowerCase().startsWith(searchTerms[0].toLowerCase());
            });
            return valExists;
        });
    
        if (searchTerms[1]) {
            filteredData = filteredData.filter((v: any) => {
                const val = v["processorNum"] ? v["processorNum"] : "";
                return val.toString().toLowerCase().startsWith(searchTerms[1].toLowerCase());
            });
        }
    
        return filteredData.slice(0, 20);
    }

  showPopup() {
    this.isPopupVisible = true;
  }
  openInsuPopup(){
    this.insuPopupOpen = true;
    this.InsuCardsFG.reset();
    this.isFrmInsuranceCapture = false;
    this.enableForControls();
  }
  closeInsuPopup(){
    this.insuPopupOpen = false;
    this.isFrmInsuranceCapture = false;
    this.enableForControls();
    this.errorMessage = '';
    this.selectedOption = null;
  }

  openCamera(facingMode: 'user' | 'environment' = 'environment') {
    this.isCaptured = true;
    this.capturedImage = null;
    navigator.mediaDevices.getUserMedia({
      video: { facingMode },
      audio: false
    }).then((stream) => {
      this.stream = stream;
      this.video.nativeElement.srcObject = stream;
      this.isFrmInsuranceCapture = true;
    }).catch((err) => {
      alert('Unable to access the camera. Please check permissions or try another device.');
    });
  }
  
  captureAndUploadImage() {    
    const videoEl = this.video.nativeElement as HTMLVideoElement;
    const canvasEl = this.canvas.nativeElement as HTMLCanvasElement;
    canvasEl.width = videoEl.videoWidth;
    canvasEl.height = videoEl.videoHeight;
    const context = canvasEl.getContext('2d');
    if (context) {
      context.drawImage(videoEl, 0, 0, canvasEl.width, canvasEl.height);
      this.capturedImage = canvasEl.toDataURL('image/png'); // Base64 image
    }
    this.stopCamera();
    if (this.capturedImage) {
      this.isImageCaptured = true;
      this.extractedImage = this.base64ToFile(this.capturedImage, 'capturedImage.png');
      this.isFrmInsuranceCapture = true;
      this.errorMessage = '';
    }
  }

  base64ToFile(base64String: string, filename: string): File {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }
  retry(){
    this.isImageCaptured=false;
    this.isCaptured = true;    
    this.capturedImage = null;
    this.stopCamera();
    this.openCamera('environment');
  }
  triggerFileUpload(): void {
    this.fileInput.nativeElement.click();
  }
  onFileSelected(event: Event): void {
    this.capturedImage = null;
    this.errorMessage = '';
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files[0]) {
      const file = input.files[0];    
      if (file) {
        const maxSizeInMB = 10;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
        const allowedExtensions = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedExtensions.includes(file.type)) {
          this.showError("Only JPEG, PNG and JPG formats are allowed.");
        } else if (file.size > maxSizeInBytes) {
          this.showError("File size should not exceed 10 MB.");
        } else {
          const fileType = file.type.split('/')[1]; 
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.capturedImage = e?.target?.result; // Base64 data
            if (this.capturedImage) {
              this.extractedImage = this.base64ToFile(this.capturedImage, 'capturedImage.png');
              this.isFrmInsuranceCapture = true;
              this.insuranceOCRExtraction();
            }
          };
          reader.readAsDataURL(file); 
        }
      }
    }
  }
  
  showError(message: string): void {
    this.errorMessage = message;
  }
  insuranceOCRExtraction(){
    let fd = new FormData();
    const pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
    const data = {
      PatientId: this.patientProfileData?.patientInfo?.patientid,
      TenantId : pharmacyInfo?.tenantId
    }
    if (this.extractedImage?.type === 'image/png' || this.extractedImage?.type === 'image/jpeg' || this.extractedImage?.type === 'image/jpg') {
        fd.append("DocInputParams", JSON.stringify(data));
        fd.append("fileKey", this.extractedImage);
        this._peSvc.InsuranceOCRInfo(fd).subscribe((resp) => {
                if (resp && Object.keys(resp).length > 0) {
                  this.InsuCardsFG.patchValue({
                    InsuranceName: resp?.Insurer || '',
                    BIN: resp?.RxBIN || '',
                    PCN: resp?.RxPCN || '',
                    GroupNumber: resp?.RxGRP || '',
                    PolicyNumber: resp?.IdNumber || '',
                    PhoneNumber: resp?.PhoneNumber || '',
                    PersonCode: resp?.IdNumberSuffix || ''
                  });
                  if (this.checkDuplicateInsuranceAndHandle(this.InsuCardsFG)) {
                    return;
                  }
                } else{
                  this.showError("Oops! Try a valid scan or enter manually.");
                }
                this.isCaptured = false;
            });
    }
  }

  closeCaptureImagePopup(){
    this.isCaptured = false;
    this.capturedImage = null;
    this.isImageCaptured = false;
    this.stopCamera();
  }
  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  selectOption(option: any) {
    this.selectedOption = option;
    this.InsuCardsFG.patchValue({Priority : option?.Id});
    this.showDropdown = false;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(event?.target)) {
      this.showDropdown = false;
    }
  }

checkDuplicateInsuranceAndHandle(form: FormGroup, showError: boolean = true): boolean {
  const bin = form.get('BIN')?.value?.trim();
  const policynum = form.get('PolicyNumber')?.value?.trim()?.toLowerCase();
  const pcn = form.get('PCN')?.value?.trim()?.toLowerCase();
  
  // Reset flags first
  if (!bin || !policynum) {
    this.isInsuranceExists = false;
    this.errorMessage = '';
    return false;
  }
  
  // Check for duplicate
  const isDuplicate = this.patientProfileData?.patientInfo?.insurance?.some((ins: any) => {
    // const matchBIN = ins.binnum?.trim() === bin;
    const matchInsuId = ins.policynum?.trim()?.toLowerCase() === policynum;
    // const matchPCN = pcn ? ins.processorNum?.trim()?.toLowerCase() === pcn : true;
    return matchInsuId;
  });
    if (isDuplicate) {
    this.isInsuranceExists = true;
    this.errorMessage = "Patient already has the selected Insurance.";
  } else {
    this.isInsuranceExists = false;
    this.errorMessage = '';
  }
  
  return isDuplicate;
}

  saveInsuraceData(){
     if (this.isInsuranceExists || this.isInsuranceInactive) {
        return;
    }
    this.InsuCardsFG?.controls?.["PharmacyNPI"].patchValue(this.elinkParams?.npi);
    this.InsuCardsFG?.controls?.["PatientId"].patchValue(this.patientProfileData?.patientInfo?.patientid);
    this.InsuCardsFG?.controls?.["InsuranceName"].patchValue(this.InsuCardsFG.controls["InsuranceName"].value);
    this.normalizePhoneNumber();
    this.insuPopupOpen = false;
    this.enableForControls();
    const payload = {
      patientId : this.InsuCardsFG?.controls?.["PatientId"]?.value,
      pharmacyNPI : this.InsuCardsFG?.controls?.["PharmacyNPI"]?.value,
      insurerId : this.insurerId,
      groupName : this.InsuCardsFG?.controls?.["GroupNumber"]?.value,
      policyNumber : this.InsuCardsFG?.controls?.["PolicyNumber"]?.value,
      personCode : this.InsuCardsFG?.controls?.["PersonCode"]?.value,
      insuPriorityId : this.InsuCardsFG?.controls["Priority"]?.value ? this.InsuCardsFG.controls["Priority"].value : 0,
      isPhoneNumUpdated : this.isPhoneNumUpdated,
      phoneNumber : this.InsuCardsFG?.controls?.["PhoneNumber"]?.value
    }
    if(this.binPcnExists){
      this._peSvc.addExistanceInsuranceforPatient(payload).subscribe((resp)=>{
        if(resp){
          this.gerProfile();
          this.binPcnExists = false;
        }
      })
    } else if(this.InsuCardsFG.value && !this.isFrmInsuranceCapture){
      this.InsuCardsFG.patchValue({Priority : this.InsuCardsFG?.controls["Priority"]?.value ? this.InsuCardsFG.controls["Priority"].value : 0});
      this._peSvc.addNewInsuranceforPatient(this.InsuCardsFG.value).subscribe((resp)=>{
        this.gerProfile();
        this.binPcnExists = false;
      });
        this.errorMessage = '';
    } else if(this.InsuCardsFG.value && this.isFrmInsuranceCapture){
        this.InsuCardsFG.patchValue({Priority : this.InsuCardsFG?.controls["Priority"]?.value ? this.InsuCardsFG.controls["Priority"].value : 0});
        let fd = new FormData();
        const pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
        const data = {
          PatientId: this.patientProfileData?.patientInfo?.patientid,
          TenantId : pharmacyInfo?.tenantId
        }
        fd.append("DocInputParams", JSON.stringify(data));
        fd.append("fileKey", this.extractedImage);
        this._peSvc.SaveInsuranceOCRInfo(fd).subscribe((res)=>{
          if(res){
            this._peSvc.addNewInsuranceforPatient(this.InsuCardsFG.value).subscribe((resp)=>{
              this.gerProfile();
              this.binPcnExists = false;
            });
          } else {
            this.gerProfile();
          }
          this.errorMessage = '';
        })
    } else{
      this.binPcnExists = false;
    }
    this.extractedImage = null;
    this.selectedOption = null;
  }
  
  validateField(fieldName: string, fieldElement: HTMLElement) {
    const control = this.InsuCardsFG.get(fieldName);
    if (control && control.invalid && control.errors?.required) {
      fieldElement.focus();
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.keyCode);
    if (!/^\d$/.test(inputChar)) {
      event.preventDefault(); // Block non-numeric input
      this.isInsuranceExists = false;
      this.isInsuranceInactive = false;
    }
  }
  onPhoneNumberInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, '').slice(0, 10); // Keep only digits, max 10
  const areaCode = value.substring(0, 3);
  const middle = value.substring(3, 6);
  const last = value.substring(6);
  if (value.length > 6) {
    input.value = `(${areaCode})-${middle}-${last}`;
  } else if (value.length > 3) {
    input.value = `(${areaCode})-${middle}`;
  } else if (value.length > 0) {
    input.value = `(${areaCode}`;
  }
  // Only update the PhoneNumber form control
  this.InsuCardsFG.controls['PhoneNumber'].setValue(input.value, { emitEvent: false });
}

  // Restricts input to exactly 6 digits and moves focus if valid
  restrictToSixDigits(currentField: HTMLInputElement, nextField: HTMLInputElement) {
    currentField.value = currentField.value.replace(/\D/g, '').slice(0, 6); // Allow only numbers & restrict to 6 digits
  
    if (currentField.value.length === 6) {
      this.InsuCardsFG.controls['BIN'].setErrors(null); // Clear error
      nextField.focus(); // Move to the next field
    } else {
      this.InsuCardsFG.controls['BIN'].setErrors({ invalidLength: true }); // Set error if not 6 digits
      currentField.focus(); // Keep focus in BIN field
    }
  }
  
  
  // Validates the field on blur
  validateAndFocus(currentField: HTMLInputElement, nextField: HTMLInputElement) {
    if (currentField?.value?.length !== 6) {
      this.InsuCardsFG.controls['BIN'].setErrors({ invalidLength: true }); // Set error
      this.InsuCardsFG.controls['BIN'].markAsTouched(); // Mark field as touched for validation message
      currentField.focus(); // Keep focus in BIN field
    } else {
      this.InsuCardsFG.controls['BIN'].setErrors(null); // Clear error when valid
      nextField.focus(); // Move to the next field
    }
  }
  
  
  isFieldInvalid(fieldName: string) {
    const control = this.InsuCardsFG.get(fieldName);
    return (control?.touched && (control?.hasError('required')) || (control?.hasError('invalidLength'))); // Only check invalid length
  }

  skipIfDisabled(event: FocusEvent, fieldName: string) {
    const control = this.InsuCardsFG.get(fieldName);
    if (control && control.disabled) {
      event.preventDefault();
      this.focusNextEnabledField(fieldName);
    }
  }
  
  focusNextEnabledField(currentField: string) {
    const fieldsOrder = ['InsuranceName', 'BIN', 'PCN', 'GroupNumber', 'PhoneNumber', 'PolicyNumber', 'PersonCode', 'Priority'];
    const currentIndex = fieldsOrder.indexOf(currentField);
    for (let i = currentIndex + 1; i < fieldsOrder.length; i++) {
      const nextField = this.InsuCardsFG.get(fieldsOrder[i]);
      if (nextField && nextField.enabled) {
        const nextFieldElement = document.querySelector(`[formControlName="${fieldsOrder[i]}"]`) as HTMLElement;
        if (nextFieldElement) {
          nextFieldElement.focus();
          break;
        }
      }
    }
  }
  
  displayPhoneNumber(phoneNumber: any): string {
    if (!phoneNumber) return '';
    const phone = phoneNumber.replace(/\D/g, '');
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3');
  }
  
  showPreviousCard() {
    if (this.currentCardIndex > 0) {
      this.currentCardIndex--;
      this.updateVisibleDots();
      this.isAllCardsVisible = false;
    }
  }
  showNextCard() {
    if (this.currentCardIndex < this.patientProfileData?.patientInfo?.insurance.length - 1) {
      this.currentCardIndex++;
      this.updateVisibleDots();
      this.isAllCardsVisible = false;
    }
  }
  goToCard(index: number) {
    this.currentCardIndex = index;
    this.updateVisibleDots();
    this.isAllCardsVisible = false;
  }
  updateVisibleDots() {
    const insuranceList = this.insuranceData ? Object.assign([], this.insuranceData) : [];
    if (insuranceList && insuranceList.length > 0) {
      this.patientProfileData?.patientInfo?.insurance.forEach((data: any) => {
        this.matchingInsurance = insuranceList.find((x: any) => 
          data?.binnum === x?.binNum && data?.processorNum?.trim() === x?.processorNum?.trim()
        );
        if (this.matchingInsurance) {
          this.insuPhoneNumber = this.matchingInsurance.phoneNumber;
          data.phoneNumber = this.insuPhoneNumber;
        }
      });
    }
    const totalCards = this.patientProfileData?.patientInfo?.insurance.length;
    if (totalCards <= 3) {
      this.visibleDots = Array.from({ length: totalCards }, (_, i) => i);
    } else {
      if (this.currentCardIndex === 0) {
        this.visibleDots = [0, 1, 2];
      } else if (this.currentCardIndex === totalCards - 1) {
        this.visibleDots = [totalCards - 3, totalCards - 2, totalCards - 1];
      } else {
        this.visibleDots = [
          this.currentCardIndex - 1,
          this.currentCardIndex,
          this.currentCardIndex + 1,
        ];
      }
    }
  }
  closePopup(event : string) {
    if(event){
      this.avatarUrl = event;
    } else{
      this.setAvatarUrl(this.patientProfileData?.patientInfo?.gender);
    }
    this._profileSvc.setImage(this.avatarUrl);
    this.avatarUrl = this.avatarUrl;
    this.isPopupVisible = false;
    this.errorMessage = '';
  }

  normalizePhoneNumber(): void {
    const formattedValue = this.InsuCardsFG.controls['PhoneNumber'].value || '';
    const normalizedValue = formattedValue.replace(/\D/g, '');
    this.InsuCardsFG.controls['PhoneNumber'].setValue(normalizedValue, { emitEvent: false });
  }
  categorizeInsuranceRecords(): void {
    let counter = 0; 
    const processedRecords = new Set<string>(); 
    if(this.patientProfileData && this.patientProfileData?.patientInfo?.insurance) {
        this.patientProfileData?.patientInfo?.insurance.forEach((insuranceGroup: InsuranceGroup, i: number) => {
          if ((this.getInsuranceByPriority(insuranceGroup?.insuPriId).length > 0 || insuranceGroup?.insurancename)
              && !this.hasDisplayed(insuranceGroup?.insuPriId, i)) { 
            let category = '';
            if (counter < 3) { 
              category = insuranceGroup?.insuPriId != null ?
                (insuranceGroup?.insuPriId === 1 ? 'Primary - ' + (insuranceGroup?.insurancename || '') :
                  insuranceGroup?.insuPriId === 2 ? 'Secondary - ' + (insuranceGroup?.insurancename || '') :
                  insuranceGroup?.insuPriId === 3 ? 'Tertiary - ' + (insuranceGroup?.insurancename || '') : '') : '';
            } else { 
              category = category || insuranceGroup?.insurancename || '---';
            } 
            const identifier = insuranceGroup?.insuPriId + insuranceGroup?.insurancename; 
            if (!processedRecords.has(identifier)) {
              this.categorizedRecords.push({ category, insuranceGroup });
              processedRecords.add(identifier); 
              counter++; 
            }
          }
        });
    }
  }

  async gerProfile() {
     console.log("profile comp==> gerProfile")
    this.patientProfileData = await this.smsService.getPatientProfile(); 
    if(this.patientProfileData){ 
        this.PatientPhoneNo = this.commmonUtil.formatPhone(this.patientProfileData?.patientInfo?.mobile); 
        this.patallergiesData = this.patientProfileData?.patientInfo?.patallergies;
        const gender = this.patientProfileData?.patientInfo?.gender;
        if (this.patientProfileData?.patientInfo.profilePictureId) {
          this.pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
          if (this.pharmacyInfo) {
            this.pharmacyName = this.pharmacyInfo?.name;
          }
          console.log("loadProfilePicture: pharmacyName:", this.pharmacyName);          
          this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
          this.npi = this.elinkParams?.npi;
          console.log("loadProfilePicture: npi:", this.npi);

          const payload={
            profilePictureId: this.patientProfileData?.patientInfo?.profilePictureId,
            npi:this.elinkParams?.npi,
            pharmacyName: this.pharmacyName,
            patientid: this.patientProfileData?.patientInfo?.patientId,
            fullname: this.patientProfileData?.patientInfo?.fullName
          }
          this.avatarUrl=await this._peSvc.getProfilePictureUrl(payload);
          this.patientProfileData.blobImageUrl = this.avatarUrl;
          this._profileSvc.setImage(this.avatarUrl); 
        } else{
          this.setAvatarUrl(gender);
        }
        const dob = new Date(this.patientProfileData?.patientInfo?.dob);
        this.patAge = this.commmonUtil.calculateAge(dob);
        this.categorizeInsuranceRecords();
        this.extractedImage = null;
    }  
  }
  setAvatarUrl(gender: string) {
		if (gender?.toLowerCase() === 'male') {
        this.avatarUrl = '/assets/images/male_pic.png';
      } else if (gender?.toLowerCase() === 'female') {
        this.avatarUrl = '/assets/images/female_pic.png';
      } else {
        this.avatarUrl = '/assets/images/dp_pic.png';
		}
	}
  getInsuranceByPriority(priority: number): Insurance[] {
    return this.patientProfileData?.patientInfo?.insurance.filter((insurance: Insurance) => insurance.insuPriId === priority) || []; 
  }  
  hasDisplayed(insuPriId: number, currentIndex: number): boolean {
    return this.patientProfileData?.patientInfo?.insurance
      .slice(0, currentIndex)
      .some((insurance: Insurance)  => insurance.insuPriId === insuPriId);
  }
  ngOnDestroy() {
    window.removeEventListener('resize', this.adjustPaymentListHeight.bind(this));
  }

  goBack() {
    console.log(window, window.history)
  if (window.history.length > 1) {
    window.history.back();
  } else {
    this._router.navigate(['/dashboard']);
  }
}
}